import { BACKEND_URL } from "../env";
import { AdminOverview } from "../types/admin";

/** Fetches the read-only platform overview. Returns null on any failure. */
export async function fetchAdminOverview(): Promise<AdminOverview | null> {
  try {
    const response = await fetch(`${BACKEND_URL}/admin/overview`, {
      credentials: "include",
      cache: "no-store",
    });

    if (response.status >= 400) {
      return null;
    }

    return (await response.json()) as AdminOverview;
  } catch {
    return null;
  }
}
